/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const formSubmissionQuestionDataSchema = z.object({
	question: z.string(),
	position: z.string(),
	answers: z.array(
		z.object({ answer: z.string().nullable(), optionId: z.string().nullable(), updatedAt: z.iso.datetime() }),
	),
	updatedAt: z.iso.datetime(),
	options: z.array(z.object({ id: z.string(), label: z.string() })).nullable(),
})

export type FormSubmissionQuestionDataSchema = z.infer<typeof formSubmissionQuestionDataSchema>
